import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import CategoryProgramContain from '../../../Component/Learning/CategoryProgram';

const CategoryProgramPage = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Category Program" title="Daftar Category Program" />
      <CategoryProgramContain />
    </Fragment>
  );
};
export default CategoryProgramPage;